import styled from "styled-components";

export const Box = styled.div`

.interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
    }
  .me-2 {
  background-color: #8cc540;
  }
  .me-2:hover {
  background-color: #8cc540;
  }
`;